import { render, staticRenderFns } from "./CompleteSingeMusicAuthInfo.vue?vue&type=template&id=275e430b&scoped=true"
import script from "./CompleteSingeMusicAuthInfo.vue?vue&type=script&lang=js"
export * from "./CompleteSingeMusicAuthInfo.vue?vue&type=script&lang=js"
import style0 from "./CompleteSingeMusicAuthInfo.vue?vue&type=style&index=0&id=275e430b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e430b",
  null
  
)

export default component.exports